(() => {
  const sectionName = 'dtc-landing-hero';

  if (sectionName in Shopify.theme.sections.registered) {
    const sections = document.querySelectorAll(`[data-section-type=${sectionName}]`);

    sections.forEach((section, index) => {
      if (index !== 0) {
        const linkTag = section.querySelector('link');
        const scriptTag = section.querySelector('script');

        linkTag.remove();
        scriptTag.remove();
      }
    });
  } else {
    const selectors = {
      container: '.image-with-text',
      button: '.button-dtc',
      scrollTo: '.dtc-scroll-section'
    }

    function scrollToSection(event) {
      event.preventDefault();

      const section = document.querySelector(selectors.scrollTo);
      const sectionOffset = section.offsetTop;

      window.scrollTo({
        top: sectionOffset,
        behavior: 'smooth'
      });
    }

    const wrapper = document.querySelector(selectors.container);
    const buttonToScroll = wrapper.querySelector(selectors.button);

    buttonToScroll?.addEventListener('click', scrollToSection);
    Shopify.theme.sections.register(sectionName);
  }
})()
